import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { faFileInvoiceDollar, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { ExpenseService } from 'src/app/share/services/expense/expense.service';

@Component({
  selector: 'app-day-book-expenses',
  templateUrl: './day-book-expenses.component.html',
  styleUrls: ['./day-book-expenses.component.scss'],
  standalone: false
})
export class DayBookExpensesComponent implements OnChanges {
  protected readonly faFileInvoiceDollar = faFileInvoiceDollar;
  protected readonly faChevronRight = faChevronRight;

  @ViewChild('expensesModal') expensesModalTemplate!: any;
  @ViewChild('detailedExpensesModal') detailedExpensesModalTemplate!: any;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  totalEntries: number = 0;
  totalAmount: number = 0;
  avgPerTyre: number = 0;
  changeValue: string = '';
  expensesList: any[] = [];
  loader: boolean = false;
  errMsg: string = "";

  detailedExpensesList: any[] = [];
  detailLoader: boolean = false;
  detailErrMsg: string = '';

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmsService: CommonServiceService,
    private readonly expenseService: ExpenseService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.totalEntries = 0;
      this.totalAmount = 0;
      this.expensesList = [];
      this.getData();
    }
  }

  getData() {
    this.loader = true;
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getExpenses(params).subscribe({
      next: (res: any) => {
        this.loader = false
        this.mapResponse(res.data || {})
      },
      error: (err: any) => {
        this.loader = false;
        this.errMsg = err.error.error.message || "Failed to fetch response"
      }
    })
  }

  mapResponse(data: any) {
    this.totalEntries = this.cmsService.parseNumberOrZero(data?.totalEntries);
    this.totalAmount = this.cmsService.parseNumberOrZero(data?.totalValue);
    this.avgPerTyre = this.cmsService.parseNumberOrZero(data?.avgPerEntry);
    this.changeValue = data?.entriesChange || '';
    if (data.breakdown?.length) {
      let tabledata: any[] = (data.breakdown || []).map((item: any) => {
        return { ...item, count: this.cmsService.parseNumberOrNull(item?.count), amount: this.cmsService.parseNumberOrNull(item?.totalValue) };
      });
      this.expensesList = tabledata
    } else {
      this.errMsg = 'No data found'
    }
  }

  viewAllExpenses() {
    this.modalService.open(this.expensesModalTemplate, { size: 'lg', centered: true, scrollable: true });
  }

  detailPage: number = 0;
  detailEndOfResult: boolean = false;
  detailFilters: any = {};

  onRowClick(item: any) {
    this.modalService.dismissAll();
    this.detailedExpensesList = [];
    this.detailPage = 0;
    this.detailEndOfResult = false;
    this.detailFilters = {
      created_datefrom: this.selectedDate,
      created_dateupto: this.selectedDate,
    };
    if (item.category) {
      this.detailFilters.category_in = item.category;
    }
    if (item.company) {
      this.detailFilters.company = item.company;
    }
    this.getDetailedExpenses(false);
    this.modalService.open(this.detailedExpensesModalTemplate, { size: 'lg', centered: true, scrollable: true });
  }

  getDetailedExpenses(append: boolean = false) {
    if (this.detailLoader) return;
    this.detailLoader = true;
    this.detailErrMsg = '';
    const params: any = {
      page: this.detailPage,
      ...this.detailFilters
    };
    this.expenseService.getExpenseList(params).subscribe({
      next: (res: any) => {
        this.detailLoader = false;
        const data = res.data || [];
        if (append) {
          this.detailedExpensesList = [...this.detailedExpensesList, ...data];
        } else {
          this.detailedExpensesList = data;
        }

        if (data.length === 0 || data.length < 20) {
          this.detailEndOfResult = true;
        } else {
          this.detailEndOfResult = false;
        }
      },
      error: (err: any) => {
        this.detailLoader = false;
        this.detailErrMsg = err?.error?.error?.message || "Failed to fetch detailed expenses";
      }
    });
  }

  onScrollDetail() {
    if (this.detailLoader || this.detailEndOfResult) return;
    this.detailPage++;
    this.getDetailedExpenses(true);
  }

}
